import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/Button';
import { MenuIcon, XIcon, ChevronDownIcon, CheckCircleIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Developers',
    path: '/developers'
  }, {
    name: 'Jobs',
    path: '/jobs'
  }, {
    name: 'For Companies',
    path: '/post-job'
  }, {
    name: 'Pricing',
    path: '/pricing'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMenuOpen ? 'bg-[#0F1115]/90 backdrop-blur-md border-b border-gray-800' : 'bg-transparent'}`} data-id="element-105">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <div className="flex items-center justify-between h-20" data-id="element-107">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-id="element-108">
            <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-red-500/20 transition-all duration-300" data-id="element-109">
              <CheckCircleIcon className="w-6 h-6 text-[#d73b3e]" data-id="element-110" />
            </div>
            <span className="font-display font-bold text-xl text-white tracking-tight" data-id="element-111">
              Certified<span className="text-[#d73b3e]" data-id="element-112">Devs</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-113">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors duration-200 ${isActive(link.path) ? 'text-[#d73b3e]' : 'text-gray-300 hover:text-white'}`} data-id="element-114">
                {link.name}
              </Link>)}
          </nav>

          {/* Auth Buttons */}
          <div className="hidden md:flex items-center gap-4" data-id="element-115">
            <Link to="/login" className="text-sm font-medium text-gray-300 hover:text-white transition-colors" data-id="element-116">
              Log in
            </Link>
            <Link to="/signup" data-id="element-117">
              <Button variant="primary" size="sm" className="shadow-lg shadow-red-500/20 hover:shadow-red-500/30" data-id="element-118">
                Get Certified
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-gray-300 hover:text-white transition-colors" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-119">
            {isMenuOpen ? <XIcon className="w-6 h-6" data-id="element-120" /> : <MenuIcon className="w-6 h-6" data-id="element-121" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-[#0F1115] border-b border-gray-800" data-id="element-122">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-123">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`block px-3 py-3 rounded-lg text-base font-medium ${isActive(link.path) ? 'bg-red-500/10 text-[#d73b3e]' : 'text-gray-300 hover:bg-gray-800 hover:text-white'}`} onClick={() => setIsMenuOpen(false)} data-id="element-124">
                {link.name}
              </Link>)}
            <div className="pt-4 mt-4 border-t border-gray-800 flex flex-col gap-3" data-id="element-125">
              <Link to="/login" className="block px-3 py-3 text-center rounded-lg text-base font-medium text-gray-300 hover:bg-gray-800 hover:text-white" onClick={() => setIsMenuOpen(false)} data-id="element-126">
                Log in
              </Link>
              <Link to="/signup" onClick={() => setIsMenuOpen(false)} data-id="element-127">
                <Button className="w-full justify-center" data-id="element-128">Get Certified</Button>
              </Link>
            </div>
          </div>
        </div>}
    </header>;
};